import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sensor-groups-view" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "font-weight-medium" }
const _hoisted_4 = { class: "text-h5" }

import { ref, onMounted, computed, nextTick } from 'vue'
import { useSensorGroupStore } from './store'
import { SensorGroup } from './models/sensorGroup'


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorGroupsView',
  setup(__props) {

const sensorGroupStore = useSensorGroupStore()
const loading = ref(false)
const dialog = ref(false)
const deleteDialog = ref(false)
const editedIndex = ref(-1)
const editedItem = ref(new SensorGroup())
const defaultItem = new SensorGroup()
const itemToDelete = ref<SensorGroup | null>(null)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Nombre', key: 'name' },
  { title: 'Creado', key: 'createdAt' },
  { title: 'Actualizado', key: 'updatedAt' },
  { title: 'Creado por', key: 'createdBy' },
  { title: 'Acciones', key: 'actions', sortable: false, width: '150px' },
]

const nameRules = [
  (v: string) => !!v || 'El nombre es requerido',
  (v: string) => (v && v.length >= 2) || 'El nombre debe tener al menos 2 caracteres',
]

const sensorGroupsList = computed(() => sensorGroupStore.sensorGroups)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const refreshData = async () => {
  loading.value = true
  try {
    await sensorGroupStore.getSensorGroups()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  editedIndex.value = -1
  editedItem.value = Object.assign({}, defaultItem)
  dialog.value = true
}

const editItem = (item: SensorGroup) => {
  editedIndex.value = sensorGroupsList.value.indexOf(item)
  editedItem.value = Object.assign({}, item)
  dialog.value = true
}

const deleteItem = (item: SensorGroup) => {
  itemToDelete.value = item
  deleteDialog.value = true
}

const viewSensors = (item: SensorGroup) => {
  // Navegar a la vista de sensores del grupo o mostrar un dialog con los sensores
  console.log('View sensors for group:', item.name)
  // Aquí podrías navegar a una ruta como /sensor-groups/:id/sensors
  // o mostrar un dialog con la lista de sensores del grupo
}

const close = () => {
  dialog.value = false
  nextTick(() => {
    editedItem.value = Object.assign({}, defaultItem)
    editedIndex.value = -1
  })
}

const save = async () => {
  try {
    if (editedIndex.value > -1) {
      // Editar grupo existente
      await sensorGroupStore.putSensorGroup(editedItem.value)
    } else {
      // Crear nuevo grupo
      await sensorGroupStore.postSensorGroup(editedItem.value)
    }
    await refreshData()
    close()
  } catch (error) {
    console.error('Error saving sensor group:', error)
  }
}

const confirmDelete = async () => {
  if (itemToDelete.value) {
    try {
      await sensorGroupStore.deleteSensorGroup(itemToDelete.value.id)
      await refreshData()
    } catch (error) {
      console.error('Error deleting sensor group:', error)
    }
  }
  deleteDialog.value = false
  itemToDelete.value = null
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("h1", null, "Sensor Groups", -1),
                _createElementVNode("p", null, "Gestión de grupos de sensores", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: sensorGroupsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("Lista de Grupos de Sensores")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[9] || (_cache[9] = _createTextVNode(" Agregar Grupo "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.name": _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_icon, {
                        class: "mr-2",
                        color: "primary"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-folder-multiple")
                        ])),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)
                    ])
                  ]),
                  "item.createdAt": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.createdAt)), 1)
                  ]),
                  "item.updatedAt": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.updatedAt)), 1)
                  ]),
                  "item.createdBy": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.createdBy), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (viewSensors(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("mdi-eye")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode(" Ver sensores del grupo ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("mdi-pencil")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" Editar grupo ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("mdi-delete")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode(" Eliminar grupo ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: dialog.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
          "max-width": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(editedIndex.value === -1 ? 'Nuevo Grupo' : 'Editar Grupo'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: editedItem.value.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedItem.value.name) = $event)),
                                  label: "Nombre del Grupo",
                                  required: "",
                                  rules: nameRules
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue-darken-1",
                      variant: "text",
                      onClick: close
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode(" Cancelar ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "blue-darken-1",
                      variant: "text",
                      onClick: save
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode(" Guardar ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: deleteDialog.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deleteDialog).value = $event)),
          "max-width": "400px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-h5" }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("¿Confirmar eliminación?")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" ¿Estás seguro de que quieres eliminar el grupo \"" + _toDisplayString(itemToDelete.value?.name) + "\"? Esta acción no se puede deshacer. ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue-darken-1",
                      variant: "text",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteDialog.value = false))
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode(" Cancelar ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "red-darken-1",
                      variant: "text",
                      onClick: confirmDelete
                    }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode(" Eliminar ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})